/** @jsx jsx */
import { gql } from '@apollo/client';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import {
  hasDifferentExhibitor,
  ProductHeaderDetails,
  ProductHeaderDetailsFragment,
  ProductName,
  ProductNameFragment,
  ProductProducer,
  ProductProducerNameFragment,
  ProductStand,
  ProductStandFragment,
} from '../Product/ProductHeader';
import ProductImageCol, {
  ProductImageFragment_large,
} from '../ProductPage/ProductImageCol';
import {
  ProductMainCol,
  ProductNavigation,
  ProductPageHeaderRow,
} from '../ProductPage/ProductPageHeader';

export default function EventProductPageHeader({
  product,
  next,
  previous,
  getProductLink,
  standPath,
  overlapImage,
}) {
  const hasOtherExhibitor = hasDifferentExhibitor(product);
  return (
    <ProductPageHeaderRow sx={{ justifyContent: 'center' }}>
      <ProductImageCol product={product} overlap={overlapImage} />
      <ProductMainCol>
        <ProductStand
          stand={product?.stand}
          exhibitor={hasOtherExhibitor && product?.exhibitor}
          to={hasOtherExhibitor && standPath}
        />
        <ProductProducer
          producer={product?.producer}
          to={!hasOtherExhibitor && standPath}
        />
        <ProductName as="h1" product={product} />
        <ProductHeaderDetails product={product} />
      </ProductMainCol>

      <ProductNavigation
        previous={previous}
        next={next}
        getLink={getProductLink}
      />
    </ProductPageHeaderRow>
  );
}

export const fragment = graphql`
  fragment EventProductPageHeader on Product {
    ...ProductImageLarge
    ...ProductStand
    ...ProductProducerName
    ...ProductName
    ...ProductHeaderDetails
  }
`;

export const EventProductPageHeaderFragment = gql`
  ${ProductImageFragment_large}
  ${ProductStandFragment}
  ${ProductProducerNameFragment}
  ${ProductNameFragment}
  ${ProductHeaderDetailsFragment}
  fragment EventProductPageHeader on Product {
    ...ProductImageLarge
    ...ProductStand
    ...ProductProducerName
    ...ProductName
    ...ProductHeaderDetails
  }
`;
